import App from '@/App';
import { initSentry } from '@/lib/sentry';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { preventEdgeTranslatorDomCrash } from './lib/preventEdgeTranslatorDomCrash';

// TODO: ちゃんと動いてないので後で確認する
if (process.env.NODE_ENV === 'development') {
  whyDidYouRender(React, {
    trackAllPureComponents: true,
  });
}

initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

preventEdgeTranslatorDomCrash();
